const CURRENCY_SYMBOLS = { USD: '$', EUR: '€', AMD: '֏', RUB: '₽' };

export const getCurrencySymbol = currency => CURRENCY_SYMBOLS[currency] ?? '';

// "0.00" -> "0" so the zero state reads cleanly; real amounts keep their cents.
export const trimZeroCents = amount => String(amount ?? 0).replace(/\.00$/, '');
